const utils = require('frontend-controller/lib/utils')
module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 40,
		preventSortOfField: {
			tags: true,
		},
		buttonContext: 'jobs',
		// showHead: false,
		// showInsertButton: false,
		// renderEmptyBeforReady: true,
		rowActionsInline: true,
		rowActionsProperties: {
			colWidth: '45px'
		},
		inline: true,
		rowActions: {
			delete: true,
			// edit: true,
			// customs: []
		},
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'jobID',
				direction: 'desc'
			}]
		}
	},

	methods: {
		// /**
		//  * this function may be overwritten to be able to sanitize the resourceFilters (param) by reference.
		//  *
		//  * @param storage			object - actual storage
		//  * @param resourceFilters	object - actual resourceFilters
		//  * @param actionKey			string - actual aktionKey
		//  */
		// sanitizeResourceFilters: function(storage, resourceFilters, actionKey){},

		// loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
		// // 	return actionKey !== 'refreshResources' || utils.collectionSize((resourceFilters || {}).filters) > 0
		// 	return true
		// },

		addEntity: function(entity){
			// add entity to dom if necessary
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		},

		showInsert: function(){
			const baseActionKey = 'showInsert_job';
			return this.performAndStoreAction(
				baseActionKey + '_inEffect',
				this.prepareAction(baseActionKey),
				true
			)
		},

		showEdit: function(rowID, rowData){
			const baseActionKey = 'showEdit_job';
			return this.performAndStoreAction(
				baseActionKey + '_inEffect',
				this.prepareAction(baseActionKey, undefined, {
					jobProperties: {
						resourceID: rowID,
					},
				}),
				true
			)
		},

		delete: function(rowID, rowData){
			if(rowID) {
				return this.performDecision(
					'confirm',
					{
						component: this,
						title: storage.__('hint.delete.really.jobs.title'),
						message: storage.__('hint.delete.really.jobs.message')
					}
				).then(context => {
					if (context.decision.type === 'yes') {
						return this.performAction(this.prepareAction('delete_job', rowID))
							.then(() => {
								this.refreshData(true)
							})
					}

					return utils.promise.reject()
				});
			}
		},
	},

	hooks: {
		attach: function($element, options){
			if(!this.model.controller){
				this.closest('templates_jobs_controller', controller =>{
					this.model.controller = controller
				})
			}

			this.model.$table = $element.find('table');
		},

		async onDecision($element, options){
			if(!options.decisionComponent.hasClass('base_modal_modal')) {
				return
			}

			const modal = options.decisionComponent

			if(options.decisionType === 'cancel'){
				return modal.hide()
			}

			let form
			if(modal.hasClass('container_templates_jobs_propertiesForm')){
				modal.find('templates_jobs_propertiesForm', c => form = c)
			}

			if(form){
				await form.submit()
			}
			await modal.hide()
			if(form){
				await this.refreshData(true)
			}
		},
	},

	// handlers: [{
	// 	name: 'recordControllerResourcesModified',
	// 	handle: function(callerComponent) {
	// 		if(this.config.isReady){
	// 			this.refreshData();
	// 		}
	// 	}
	// }]
}